import classNames from 'classnames';
import React from 'react';

const Checkbox = function(props) {
  return (
    <div className='form__checkbox' style={ props.customstyle }>
      <input className={ classNames('form__checkbox__input', props.className) }
        type='checkbox'
        { ...props } />
      <label htmlFor={ props.id } />
    </div>
  );
};

export default Checkbox;



// WEBPACK FOOTER //
// ./app/components/shared/form/_Checkbox.jsx